define(["jquery"], ($) =>
  ({ wishlistItemsThatWereAdded, response, onAboutToPresent }) => {
    let responseItems = [];
    if (
      response &&
      response.data &&
      response.data.addProductsToWishlist &&
      response.data.addProductsToWishlist.wishlist &&
      response.data.addProductsToWishlist.wishlist.items &&
      response.data.addProductsToWishlist.wishlist.items.length > 0
    ) {
      responseItems = response.data.addProductsToWishlist.wishlist.items;
    }

    let itemsToPresent = [];
    responseItems.forEach((responseItem) => {
      const { sku, parent_sku } =
        responseItem.bbnt_custom_wishlist_item_option || {};

      // early out if this item isn't one of the ones we just added
      const matchingWishlistItemThatWeIntendedToAdd =
        wishlistItemsThatWereAdded.find(
          ({ sku: expectedSku, parent_sku: expectedParentSku }) => {
            if (expectedParentSku !== null && expectedParentSku !== undefined) {
              return (
                sku === `${expectedSku}` &&
                parent_sku === `${expectedParentSku}`
              );
            }
            return sku === `${expectedSku}`;
          }
        );
      if (!matchingWishlistItemThatWeIntendedToAdd) {
        return;
      }

      // find the product that we're expecting
      let product = responseItem.product || {};
      if (parent_sku) {
        let matchingWishlistitemThatWeIntendedToAddParentSku;
        if (
          matchingWishlistItemThatWeIntendedToAdd.parent_sku !== null &&
          matchingWishlistItemThatWeIntendedToAdd.parent_sku !== undefined
        ) {
          matchingWishlistitemThatWeIntendedToAddParentSku = `${matchingWishlistItemThatWeIntendedToAdd.parent_sku}`;
        }
        if (
          parent_sku !== product.sku ||
          product.sku !== matchingWishlistitemThatWeIntendedToAddParentSku
        ) {
          return;
        }

        const thisProductsChildItems = product.items || [];
        if (thisProductsChildItems.length < 1) {
          return;
        }

        const matchingChildItem = thisProductsChildItems.find(
          ({ product }) =>
            product &&
            product.sku === sku &&
            `${matchingWishlistItemThatWeIntendedToAdd.sku}` === product.sku
        );
        if (!matchingChildItem) {
          return;
        }

        const matchingChildProduct = matchingChildItem.product;
        if (!matchingChildProduct) {
          return;
        }

        product = matchingChildProduct;
      } else {
        if (
          product.sku !== sku ||
          `${matchingWishlistItemThatWeIntendedToAdd.sku}` !== product.sku
        ) {
          return;
        }
      }

      itemsToPresent = [
        ...itemsToPresent,
        ...[
          {
            ...product,
            ...{
              quantityWishedToAdd:
                matchingWishlistItemThatWeIntendedToAdd.quantity,
            },
          },
        ],
      ];
    });

    let dataLayerWishlistItems = [];
    let itemsHtml = itemsToPresent
      .map((product) => {
        const { cart_description, thumbnail } = product;
        let itemImageSrc;
        if (thumbnail) {
          itemImageSrc = thumbnail.url;
        }

        const memberDiscount = product.price_tiers
          ? product.price_tiers[0]
          : null;
        const saleDiscount = product.price_range
          ? product.price_range.minimum_price
          : null;
        const noDiscount = product.price_range
          ? product.price_range.maximum_price
          : null;

        const noDiscountPrice = noDiscount ? noDiscount.final_price.value : 0;
        const memberDiscountedPrice = memberDiscount
          ? memberDiscount.final_price.value
          : 0;
        let saleDiscountPrice = 0;
        if (
          saleDiscount &&
          saleDiscount.regular_price &&
          saleDiscount.regular_price.value > 0 &&
          saleDiscount.regular_price.value > saleDiscount.final_price.value
        ) {
          saleDiscountPrice = saleDiscount.final_price.value;
        }

        let productPriceAfter = null;
        let productPriceBefore = null;
        let isMemberPricing = false;
        let isSalePricing = false;
        if (
          memberDiscountedPrice !== 0 &&
          memberDiscountedPrice <= saleDiscountPrice
        ) {
          productPriceBefore =
            memberDiscount.final_price.value +
            memberDiscount.discount.amount_off;
          productPriceAfter = memberDiscountedPrice;
          isMemberPricing = true;
        } else if (saleDiscountPrice !== 0) {
          productPriceBefore = saleDiscount.regular_price.value;
          productPriceAfter = saleDiscountPrice;
          isSalePricing = true;
        } else {
          productPriceAfter = noDiscountPrice;
        }

        dataLayerWishlistItems = [
          ...dataLayerWishlistItems,
          ...[
            {
              sku: product.sku,
              price: productPriceAfter,
              quantity: product.quantityWishedToAdd,
              name: cart_description,
            },
          ],
        ];

        return `
          <div class="pdp-modal-wishlist-final-step-item-container">
              <img class="pdp-modal-wishlist-final-step-item-image" src="${itemImageSrc}"/>
              <div class="pdp-modal-wishlist-final-step-item-details">
                  <p class="pdp-modal-wishlist-final-step-item-details-name">${cart_description}</p>
                  <p class="pdp-modal-wishlist-final-step-item-details-price-container ${
                    productPriceBefore !== null
                      ? "this-has-a-special-price"
                      : ""
                  }">
                    <span class="${
                      productPriceBefore !== null
                        ? "price-after"
                        : "price-regular"
                    } ${isMemberPricing ? "member-price" : ""} ${
                      isSalePricing ? "sale-price" : ""
                    }">&#36;${productPriceAfter.toFixed(2)}</span>${
                      productPriceBefore !== null
                        ? `<span class="price-before">&#36;${productPriceBefore.toFixed(
                            2
                          )}</span>`
                        : ""
                    }
                  </p>
              </div>
          </div>
        `;
      })
      .join("");

    const modalContent = `
      <div class="pdp-modal-wishlist-final-step-header">
          ${
            itemsToPresent.length > 1
              ? `<h1>WE ADDED ${itemsToPresent.length} ITEMS TO YOUR WISHLIST</h1>`
              : `<h1>WE ADDED ${itemsToPresent.length} ITEM TO YOUR WISHLIST</h1>`
          }
          <button class="action-close"></button>
      </div>
      <div class="pdp-modal-wishlist-final-step-items-container">
          ${itemsHtml}
      </div>
      <div class="pdp-modal-wishlist-final-step-footer">
          <a href="/wishlist">GO TO WISHLIST</a>
          <button class="continue-shopping-button">CONTINUE SHOPPING</button>
      </div>
    `;

    const $modalContent = $(".pdp-modal-wishlist-final-step .modal-content");
    if ($modalContent) {
      $modalContent.html(modalContent);
    }

    const $closeButton = $(".pdp-modal-wishlist-final-step .action-close");
    $closeButton.on("click", function () {
      const $modal = $(".pdp-modal-wishlist-final-step");
      if ($modal.hasClass("pdp-modal-wishlist-final-step-show")) {
        $modal.removeClass("pdp-modal-wishlist-final-step-show");
      }
      $("body").removeClass("bbnt-modal-visible-scroll-that-only");
    });

    const $continueShoppingButton = $(
      ".pdp-modal-wishlist-final-step .pdp-modal-wishlist-final-step-footer .continue-shopping-button"
    );
    $continueShoppingButton.on("click", function () {
      const $modal = $(".pdp-modal-wishlist-final-step");
      if ($modal.hasClass("pdp-modal-wishlist-final-step-show")) {
        $modal.removeClass("pdp-modal-wishlist-final-step-show");
      }
    });

    if (window.dataLayer && window.dataLayer.push) {
      dataLayerWishlistItems.forEach((item) => {
        window.dataLayer.push({
          "event": "wishlist_add_item",
          "wishlist": {
            "sku": [item.sku],
            "price": item.price,
            "qty": parseInt(item.quantity),
            "name": item.name,
          },
        });

        window.dataLayer.push({
            event: "add_to_wishlist",
            ecommerce: {
                currency: "AUD",
                value: item.price,
                items: [{
                    item_id: item.sku,
                    item_name: item.name,
                }]
            }
        });
      });
    }

    onAboutToPresent();

    const $modal = $(".pdp-modal-wishlist-final-step");
    if (!$modal.hasClass("pdp-modal-wishlist-final-step-show")) {
      $modal.addClass("pdp-modal-wishlist-final-step-show");
    }
    $("body").addClass("bbnt-modal-visible-scroll-that-only");

    const $wishlistHeaderContainer = $(".wishlist-header-container");
    const $counterQty = $wishlistHeaderContainer.find(".counter.qty");
    const $counterValue = $counterQty.find(".value");
    $counterValue.html(`${responseItems.length}`);
    if (responseItems.length > 0) {
      $counterQty.removeClass("empty");
    } else {
      $counterQty.addClass("empty");
    }
  });
